import { render, staticRenderFns } from "./Reset.vue?vue&type=template&id=c15abe74&scoped=true"
import script from "./Reset.vue?vue&type=script&lang=ts"
export * from "./Reset.vue?vue&type=script&lang=ts"
import style0 from "./Reset.vue?vue&type=style&index=0&id=c15abe74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15abe74",
  null
  
)

export default component.exports